// src/Models/projectTeamModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class ProjectTeamModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      teamID: data.teamId || data.teamID,
      projectID: data.projectId || data.projectID,
      teamName: data.teamName,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      teamId: Number(data.teamID || data.teamId || 0),
      projectId: Number(data.projectID || data.projectId || 0),
      teamName: data.teamName || '',
    };
  }
}
